import React, { useCallback, useContext, useEffect, useState } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import WebGLContext, { IChartData, IBubbleDetails } from "./WebGlContext";
import { getTagData } from "api/tags";
import { getExpressionData } from "api/expression";
import {
  getNotes,
  updateBubblePosition as apiUpdateBubblePosition,
  getLabelsMeta,
  updateLabelPos,
  getAllWidgets,
  getWidget,
  updateWidgetPosition,
  deleteWidget,
  deleteBubble,
  deleteLabel,
  deleteNote,
  getWidgetsData,
  getWidgetsMeta
} from "api/unity";
import { getFileByUniqueId } from "api/fileManager";
import { getPointCloudImages } from "api/pointCloud";
import { usePins } from "hooks/usePins";
import useUnity from "hooks/UseUnity";
import { equipmentProps, unitsProps } from "types/tagexpressiontypes";
import {
  Label,
  Widget,
  SplashScreen,
  Pin,
  ChartsContainer,
  Note,
  MinifiedMenu,
  PreviewFiles
} from "processhub-components-lib";
import { getData } from "./domain/getBubbleNotesUnitsEquipments";
import useData from "hooks/useData";
import { TagExpressionHandler } from "./domain/GetUnitEquipmentforTagsExpressions";
import { ModalContext } from "hooks/ModalProvider";
import { getFiles } from "api/fileManager";
import allHooks from "hooks";
import unityChartsContainerConfig from "config/unity/unityChartsContainerConfig'";
import unityWidgetConfig from "config/unity/unityWidgetConfig";
import noteFormConfig from "config/unity/noteFormConfig";
import labelConfig from "config/unity/LabelConfig";
import getFileExtension from "utilities/getFileExtension";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import findItemByUUID from "utilities/findItemByUuid";
import UnityMenu from "./UnityMenu/UnityMenu";

const WebGL: React.FC = () => {
  function handleCacheControl(url: any) {
    if (url.match(/\.data/) || url.match(/\.bundle/)) {
      return "must-revalidate";
    }
    if (url.match(/\.mp4/) || url.match(/\.wav/)) {
      return "immutable";
    }
    return "no-store";
  }
  const {
    unityProvider,
    sendMessage,
    isLoaded,
  } = useUnityContext({
    loaderUrl: window.vuplex ? "" : "Build/Unity/WebGL.loader.js",
    dataUrl: window.vuplex ? "" : "Build/Unity/WebGL.data",
    frameworkUrl: window.vuplex ? "" : "Build/Unity/WebGL.framework.js",
    codeUrl: window.vuplex ? "" : "Build/Unity/WebGL.wasm",
    cacheControl: handleCacheControl,
    streamingAssetsUrl: window.vuplex ? "" : "Build/Unity/StreamingAssets",
  });
  const { unityPins, unpinAllWidgets } = usePins();
  const { TimelineShown } = useUnity();
  const { modalType } = useContext(ModalContext);
  const {
    minifiedMenuItems,
    addItemToPosition,
    minifiedImgPreviewData,
    updateLeftPanel,
    updateRightPanel,
    removeMinifiedTab,
    setSelectedTabLeft,
    setSelectedTabRight
  } = useMinifiedMenu();
  const [minifiedMenuOpen, setMinifiedMenuOpen] = useState(true);

  const {
    getEquipmentInfo,
    getTagsInfo,
    pastDate
  } = useData();

  const [chartData, setChartData] = useState<IChartData[] | null>(null);
  const [bubbleDetails, setBubbleDetails] = useState<IBubbleDetails | null>(
    null
  );
  const [isMovementDisabled, setIsMovementDisabled] = useState(0);
  const [rerenderBubble, setRenderBubble] = useState(false);
  const [bubbleModalOpen, setBubbleModalOpen] = useState(false);
  const [bubblePopUp, setBubblePopUp] = useState<any>(null);
  const [chartType, setChartType] = useState<any>(null);
  const [notePopup, setNotePopup] = useState<any>(null);
  const [popupNoteId, setNoteId] = useState<number | null>(null);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [popupBubbleId, setBubbleId] = useState<number | null>(null);
  const [rerenderBubbleData, setRenderBubbleData] = useState(false);
  const [LabelPopup, setLabelPopup] = useState<any>(null);
  const [popupLabelId, setLabelId] = useState<number | null>(null);
  const [LabelModalOpen, setLabelModalOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoader, setModalLoader] = useState(true);
  const [ticketTags, updateTicketTags] = useState<number[]>([]);
  const [showPins, setShowPins] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(
    "Loading data from the network"
  );
  const [showPinned, setShowPinned] = useState(false);
  // Data
  const [allBubbles, setAllBubbles] = useState<any>(null);
  const [bubblesMeta, setBubblesMeta] = useState<any>(null);
  const [allLabels, setAllLabels] = useState<any>(null);
  const [equipments, setEquipments] = useState<equipmentProps[] | null>(null);
  const [units, setUnits] = useState<unitsProps[] | null>(null);
  const [allNotes, setAllNotes] = useState<any>(null);
  const [widgetData, setWidgetData] = useState({
    unitId: null,
    equipmentId: null,
    showEquipmentWidget: false,
    widgets: [],
    name: "",
    desc: "",
    x: 0,
    y: 0,
    z: 0
  });
  const [allWidgets, setAllWidgets] = useState<any>([]);
  const [widgetForBubbleId, setWidgetForBubbleId] = useState<number | null>(null);
  const [selectedWidget, setSelectedWidget] = useState<number | null>(null);
  const [menuVisibilityParams, setMenuVisibilityParams] = useState({ left: true, right: true });

  interface bubbleAllDetailsProps {
    bubbletype: string;
    unitId: number | null;
    equipmentId: number | null;
  }

  const [showSideMenu, setShowMenu] = useState(false);
  const [showGraph, setShowGraph] = useState(false);
  const [unpinConfirmation, setUnpinConfirmation] = useState(false);
  const [bubbleAllDetails, setbubbleAllDetails] = useState<bubbleAllDetailsProps | null>(null);
  const [pointCloudId, setPointCloudId] = useState<number | null>(null);
  const [picturesDetails, setPicturesDetails] = useState<any[]>([]);
  const [pointCloudPicId, setPointCloudPicId] = useState<any>(null);
  const [pointCloudPicData, setPointCloudPicData] = useState<any>({
    uniqueId: "",
    fileName: "",
    data: ""
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pictureLoading, setPictureLoading] = useState(false);
  const [minPicId, setMinPicId] = useState<null | number>(null);
  const [maxPicId, setMaxPicId] = useState<null | number>(null);
  const [tagsIds, setTagsIds] = useState([]);
  const [expressionIds, setExpressionsIds] = useState([]);
  const [widgetCoordinates, setWidgetCoordinates] = useState<number[]>([]);
  const [widgetModalMode, setWidgetModalMode] = useState<'none' | 'create' | 'modify' | 'delete'>('none');
  const [widgetPositionUpdate, setWidgetPositionUpdate] = useState<any>(null);
  const [itemToDelete, setItemToDelete] = useState<{ item: string, id: number | null }>({ item: '', id: null });
  const [previewData, setPreviewData] = useState<any>({ uniqueId: '', fileName: '', data: '' });

  function sendBubbleData(reload: boolean) {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  }

  useEffect(() => {
    if (selectedWidget !== null) {
      const getWidgetData = async (id: number) => {
        const response = await getWidget(id);
        if (response.status === 200) {
          setWidgetData({ ...response.data, id });
          setWidgetModalMode('modify');
        }
        else {
          console.log('error fetching widget');
        }
      };
      getWidgetData(selectedWidget);
    }
  }, [selectedWidget]);

  useEffect(() => {
    if (window.vuplex) {
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [isMovementDisabled] });
      window.vuplex.postMessage(message);
    }
  }, [isMovementDisabled]);

  useEffect(() => {
    if (modalType === 'gantt' || modalType === 'settings') {
      setShowMenu(false);
    }
  }, [modalType]);

  useEffect(() => {
    if (widgetModalMode === 'none') {
      setIsMovementDisabled(0);
      const getWidgets = async () => {
        const response = await getAllWidgets();
        if (response.status === 200) {
          setAllWidgets(response.data);
        } else {
          //error handling will be here
        }
      };
      getWidgets();
      setSelectedWidget(null);
    } else {
      setIsMovementDisabled(1);
    }
  }, [widgetModalMode]);

  useEffect(() => {
    if (allWidgets.length > 0) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetList",
            arguments: [JSON.stringify(allWidgets)]
          }
        )
      );
    }
    getWidgetsInfo();
  }, [allWidgets]);

  useEffect(() => {
    if (modalOpen || noteModalOpen || LabelModalOpen || bubbleModalOpen || isModalOpen) {
      setMinifiedMenuOpen(false);
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [1] });
      window.vuplex.postMessage(message);
    }
    else {
      setMinifiedMenuOpen(true);
      getWidgetsInfo();
      window.vuplex.postMessage(JSON.stringify({ object: "MainWidget", type: "ProcessHub.DynamicWidget.DynamicWidgetController", method: "SetWidgetList", arguments: [JSON.stringify(allWidgets)] }));
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [0] });
      window.vuplex.postMessage(message);
    }
  }, [modalOpen, noteModalOpen, LabelModalOpen, bubbleModalOpen, isModalOpen]);

  useEffect(() => {
    if (window.vuplex) {
      (async () => {
        const data: any = await getData();
        setBubblesMeta(data.BubblesMeta);
        setAllBubbles(data.BubblesData);
        setAllNotes(data.Notes);
        setEquipments(data.Equipments);
        setUnits(data.Units);
        setAllLabels(data.LabelsMeta);

        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(allNotes)] }));
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
      })();
      getWidgetsInfo();
    }
  }, [window.vuplex, location.pathname]);

  const updateNotes = async () => {
    if (window.vuplex) {
      const notesResponse = await getNotes();
      if (notesResponse.status === 200) {
        setAllNotes(notesResponse.data);
      }
      window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(allNotes)] }));
    }
  };

  const useDataFetcher = (ids: any, messageType: any, fetchDataFn: any) => {
    useEffect(() => {
      if (ids.length > 0 && window.vuplex) {
        const fetchData = async () => {
          const response = await fetchDataFn(ids, pastDate);
          if (response.status === 200) {
            sendMessage("DataManager", messageType, JSON.stringify(response.data));
          }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 60000);
        return () => clearInterval(intervalId);
      }
    }, [ids, fetchDataFn, messageType, pastDate, window]);
  };

  useDataFetcher(tagsIds, "SetTagsData", getTagData);
  useDataFetcher(expressionIds, "SetExpressionsData", getExpressionData);

  const updateLabels = async () => {
    if (window.vuplex) {
      const LabelsResponse = await getLabelsMeta();
      if (LabelsResponse.status === 200) {
        setAllLabels(LabelsResponse.data);
      }
      window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
    }
  };

  useEffect(() => {
    setRenderBubble(true);
  }, [allBubbles]);

  useEffect(() => {
    if (window.vuplex && rerenderBubbleData) {
      sendBubbleData(false);
      setRenderBubbleData(false);
    }
  }, [rerenderBubbleData, sendBubbleData, window.vuplex]);

  function resumeUnity() {
    if (isLoaded) {
      sendMessage("Utilities", "ResumeGame");
    }
  }

  function pauseUnity() {
    sendMessage("Utilities", "PauseGameFromReact");
  }

  function bubbleCloseHandler() {
    setBubbleModalOpen(false);
    setBubblePopUp(null);
    setbubbleAllDetails(null);
    resumeUnity();
  }

  useEffect(() => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
    }
  }, [window.vuplex]);

  useEffect(() => {
    if (window.vuplex && rerenderBubble) {
      sendBubbleData(true);
      setRenderBubble(false);
    }
  }, [rerenderBubble, sendBubbleData, window.vuplex]);

  useEffect(() => {
    setRenderBubbleData(true);
  }, [units]);

  useEffect(() => {
    if (window.vuplex) {
      if (allNotes) {
        const notesCollection = allNotes.map((eachNote: any) => {
          const { id, x, y, z, header, note } = eachNote;
          return { id, x, y, z, header, note };
        });
        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(notesCollection)] }));
      } else {
        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(allNotes)] }));
      }
    }
  }, [allNotes, window.vuplex]);

  useEffect(() => {
    if (window.vuplex) {
      if (allLabels) {
        const LabelsCollection = allLabels.map((eachLabel: any) => {
          const { id, x, y, z, prefabId, prefabParentId, name } = eachLabel;
          return { id, x, y, z, prefabId, prefabParentId, name };
        });
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(LabelsCollection)] }));
      } else {
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
      }
    }
  }, [allLabels, window.vuplex]);

  useEffect(() => {
    if (window.vuplex) {
      if (picturesDetails.length > 0) {
        setMinPicId(picturesDetails[0].id);
        setMaxPicId(picturesDetails[picturesDetails.length - 1].id);
        window.vuplex.postMessage(
          JSON.stringify({
            object: "__ScansManager__",
            type: "Scans.ScansManager",
            method: "SetCamerasData",
            arguments: [JSON.stringify(picturesDetails)],
          })
        );
      }
    }
  }, [picturesDetails, window.vuplex]);

  const useUnityDataEffect = (selectedData: any, apiCall: any, method: any) => {
    useEffect(() => {
      if (selectedData) {
        const fetchData = async () => {
          const response = await apiCall(selectedData, pastDate);
          const processedData = response.data;
          const message = JSON.stringify({ object: "DataManager", type: "DataManager", method, arguments: [JSON.stringify(processedData)] });
          window.vuplex.postMessage(message);
        };

        fetchData();

        const intervalId = setInterval(fetchData, 15000);

        return () => {
          clearInterval(intervalId);
        };
      }
    }, [selectedData, method, pastDate]);
  };

  useUnityDataEffect(tagsIds, getTagData, "SetTagsData");
  useUnityDataEffect(expressionIds, getExpressionData, "SetExpressionsData");

  useEffect(() => {
    if (pointCloudId !== null) {
      const getPointCloudPics = async () => {
        if (pointCloudId) {
          const response = await getPointCloudImages(pointCloudId);
          if (response.status === 200) {
            setPicturesDetails(response.data);
          }
        }
      };
      getPointCloudPics();
    }
  }, [pointCloudId]);

  const fetchPictureData = async ({
    id,
    signal,
    onSuccess,
    onError,
  }: {
    id: string;
    signal: AbortSignal;
    onSuccess: (data: any) => void;
    onError?: (error: any) => void;
  }) => {
    try {
      const response = await getFiles(id, { signal });
      if (response.status === 200) {
        onSuccess(response.data);
      }
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log('Fetch aborted');
      } else {
        console.error('Error fetching data:', error);
        if (onError) onError(error);
      }
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (pointCloudPicId !== null && !pointCloudPicData.uniqueId) {
      setPictureLoading(true);
      setTimeout(() => {
        fetchPictureData({
          id: pointCloudPicId,
          signal,
          onSuccess: (data) => {
            setPointCloudPicData(data);
            setPointCloudId(null);
            setPictureLoading(false);
          },
          onError: (error) => {
            console.log(error);
          },
        });

        window.vuplex.postMessage(
          JSON.stringify({
            objectName: "__ScansManager__",
            type: "Scans.ScansManager",
            method: "SetFileMetaIdAsViewed",
            arguments: [JSON.stringify(pointCloudPicId)],
          })
        );
      }, 0);
    }

    return () => {
      controller.abort();
    };
  }, [pointCloudPicId]);

  function createBubble(arr: number[]) {
    const bubbleDetails = {
      x: arr[0],
      y: arr[1],
      z: arr[2],
      unitId: null,
      equipmentId: null,
    };
    setBubblePopUp(bubbleDetails);
    setBubbleModalOpen(true);
    setBubbleId(null);
  }

  function createNote(arr: number[]) {
    const noteDetails = {
      x: arr[0],
      y: arr[1],
      z: arr[2],
    };
    setNotePopup(noteDetails);
    setNoteId(null);
    setNoteModalOpen(true);
  }

  function createLabel(arr: number[]) {
    const LabelDetails = {
      x: arr[0],
      y: arr[1],
      z: arr[2],
    };
    setLabelPopup(LabelDetails);
    setLabelId(null);
    setLabelModalOpen(true);
  }

  async function updateBubblePosition(bubbles: any) {
    if (bubbles) {
      const data = JSON.parse(bubbles);
      const response: any = await apiUpdateBubblePosition(data);
      if (response.status === 200) {
        refreshUnityData();
      }
    }
  }

  function configureBubbleHandler(bubbleId: any) {
    if (bubbleId) {
      setBubblePopUp(null);
      setBubbleModalOpen(true);
      setBubbleId(bubbleId);
    }
  }

  function openNote(noteId: number) {
    setNotePopup(null);
    setNoteId(noteId);
    setNoteModalOpen(true);
  }

  function openLabel(LabelId: number) {
    setLabelPopup(null);
    setLabelId(LabelId);
    setTimeout(() => {
      setLabelModalOpen(true);
    }, 500);
  }


  async function updateLabelPosition(labels: any) {
    if (labels) {
      const response = await updateLabelPos(labels);
      if (response.status === 200) {
        const labelsMetaResponse = await getLabelsMeta();
        if (labelsMetaResponse.status === 200) {
          setAllLabels(labelsMetaResponse.data);
        }
      }
    }
  }

  const tagsAndBubbleConfigHandler: any = useCallback(
    async (bubbleId: number, equipmentId: number, type: string) => {
      const bubbleTagDetails: any = await TagExpressionHandler(
        bubbleId,
        equipmentId,
        type,
        "tag"
      );

      if (type === "unconfigured") {
        setSelectedUnit(null);
        configureBubbleHandler(bubbleId);
      } else {
        setbubbleAllDetails({ bubbletype: type, unitId: bubbleTagDetails.unitId, equipmentId: type == "equipment" ? equipmentId : null });
        setSelectedUnit(bubbleTagDetails.unitId);
        setBubbleDetails(bubbleTagDetails.details);
        if (
          bubbleTagDetails.collections &&
          bubbleTagDetails.collections.length > 0
        ) {
          setChartData(bubbleTagDetails.collections);
          setModalOpen(true);
          setModalLoader(false);
          setBubbleId(bubbleId);
        } else {
          configureBubbleHandler(bubbleId);
        }
      }
    },
    [getTagsInfo, getEquipmentInfo, configureBubbleHandler, equipments]
  );

  async function expressionsHandler(bubbleId: number, assertId: number, type: string) {
    const bubbleExpressionDetails: any = await TagExpressionHandler(
      bubbleId,
      assertId,
      type,
      "expression"
    );
    setSelectedUnit(bubbleExpressionDetails.unitId);
    setBubbleDetails(bubbleExpressionDetails.details);

    setbubbleAllDetails({ bubbletype: type, unitId: bubbleExpressionDetails.unitId, equipmentId: type == "equipment" ? assertId : null });
    if (
      bubbleExpressionDetails.collections &&
      bubbleExpressionDetails.collections.length > 0
    ) {
      setChartData(bubbleExpressionDetails.collections);
      setModalOpen(true);
      setModalLoader(false);
      setBubbleId(bubbleId);
    } else {
      configureBubbleHandler(bubbleId);
    }
  }

  const noteCloseHandler = useCallback(() => {
    setNoteModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const LabelCloseHandler = useCallback(() => {
    setLabelModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const handleModalLoader = useCallback(() => {
    pauseUnity();
    setModalLoader(false);
  }, [pauseUnity]);

  const ticketTagsHandler = useCallback((tagId: number) => {
    updateTicketTags((state) => {
      const newList = [...state];
      newList.push(tagId);
      return newList;
    });
  }, []);

  const onLeftArrowClick = (id: number, position?: 'left' | 'right') => {
    const handlePanelUpdate = (
      panelData: typeof minifiedImgPreviewData["leftPanelId" | "rightPanelId"],
      updateFunction: (data: typeof minifiedImgPreviewData["leftPanelId" | "rightPanelId"]) => void,
      increment: number
    ) => {
      const newId = panelData.id + increment;
      if (id > (panelData.minPicId || 0)) {
        updateFunction({ ...panelData, id: newId, data: '', fileName: '', fileType: '' });
      }
    };

    if (position === 'left') {
      handlePanelUpdate(minifiedImgPreviewData.leftPanelId, updateLeftPanel, -1);
    } else if (position === 'right') {
      handlePanelUpdate(minifiedImgPreviewData.rightPanelId, updateRightPanel, -1);
    }

    const resetPointCloudData = (increment: number) => {
      if (pointCloudPicId !== null) {
        setPointCloudPicData({ uniqueId: "", fileName: "", data: "" });
        setPointCloudPicId((prev: number) => prev + increment);
      }
    };

    if (minPicId !== null && id > minPicId) {
      resetPointCloudData(-1);
    } else if (minPicId !== null && pointCloudPicId > minPicId) {
      resetPointCloudData(-1);
    }
  };

  const onRightArrowClick = (id: number, position?: 'left' | 'right') => {
    const handlePanelUpdate = (
      panelData: typeof minifiedImgPreviewData["leftPanelId" | "rightPanelId"],
      updateFunction: (data: typeof minifiedImgPreviewData["leftPanelId" | "rightPanelId"]) => void,
      increment: number
    ) => {
      const newId = panelData.id + increment;
      if (id < (panelData.maxPicId || Infinity)) {
        updateFunction({ ...panelData, id: newId, data: '', fileName: '', fileType: '' });
      }
    };

    if (position === 'left') {
      handlePanelUpdate(minifiedImgPreviewData.leftPanelId, updateLeftPanel, 1);
    }
    if (position === 'right') {
      handlePanelUpdate(minifiedImgPreviewData.rightPanelId, updateRightPanel, 1);
    }

    const resetPointCloudData = (increment: number) => {
      if (pointCloudPicId !== null) {
        setPointCloudPicData({ uniqueId: "", fileName: "", data: "" });
        setPointCloudPicId((prev: number) => prev + increment);
      }
    };

    if (maxPicId !== null && id < maxPicId) {
      resetPointCloudData(1);
    } else if (maxPicId !== null && pointCloudPicId < maxPicId) {
      resetPointCloudData(1);
    }
  };


  useEffect(() => {
    if (isLoaded) {
      setShowLogo(true);
      setTimeout(() => {
        setShowLogo(false);
      }, 5000);
    }
  }, [isLoaded]);

  function sendCanvasVisibility(state: number) {
    window.vuplex.postMessage(JSON.stringify({ object: "CanvasVisibility", type: "CanvasVisibility", method: "SetStatus", arguments: [state] }));
  }


  useEffect(() => {
    if (window.vuplex && location.pathname === '/3d-dashboard') {
      sendCanvasVisibility(1);
      return () => {
        sendCanvasVisibility(0);
      };
    }
    else {
      return () => {
        sendCanvasVisibility(0);
      };
    }
  }, [window.vuplex, location.pathname]);

  useEffect(() => {
    if (!isModalOpen) {
      setPictureLoading(false);
      setPointCloudPicId(null);
      setPointCloudPicData({
        uniqueId: "",
        fileName: "",
        data: ""
      });
      setIsMovementDisabled(0);
    }
  }, [isModalOpen]);

  const getWidgetsInfo = async () => {
    const widgetsData: any = await getWidgetsData();
    const widgetsMeta: any = await getWidgetsMeta();
    if (widgetsData.status === 200) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetData",
            arguments: [JSON.stringify(widgetsData.data)]
          }
        )
      );
    }
    if (widgetsMeta.status === 200) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetMeta",
            arguments: [JSON.stringify(widgetsMeta.data)]
          }
        )
      );
    }
  };


  const refreshUnityData = async () => {
    const data = await getData(true);
    setBubblesMeta(data.BubblesMeta);
    setAllBubbles(data.BubblesData);
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  };

  useEffect(() => {
    if (window.vuplex) {
      sendMessage("MainNote", "SetNotesList", JSON.stringify(allNotes));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  }, [allBubbles, bubblesMeta, allNotes]);

  const handleConfigClick = () => {
    setSelectedWidget(widgetForBubbleId);
  };

  function addMessageListener() {
    window.vuplex.addEventListener("message", async function (event: { data: any }) {
      const tjson = event.data;
      const parsedInfo = JSON.parse(tjson);
      if (parsedInfo.methodName === 'TriggerOnLeftClick') {
        const tagsAndBubblesInfo = JSON.parse(parsedInfo.message);
        setbubbleAllDetails(tagsAndBubblesInfo);
        setWidgetForBubbleId(tagsAndBubblesInfo.Id);
        setChartType(tagsAndBubblesInfo.Type);
        tagsAndBubbleConfigHandler(tagsAndBubblesInfo.Id, tagsAndBubblesInfo.AssertId, tagsAndBubblesInfo.AssertType);
      }
      if (parsedInfo.methodName === 'TriggerOnRightClick') {
        const expressions = JSON.parse(parsedInfo.message);
        setbubbleAllDetails(expressions);
        expressionsHandler(expressions.Id, expressions.AssertId, expressions.AssertType);
      }
      if (parsedInfo.methodName === 'NewBubbleAdded') {
        const bubblePoints = JSON.parse(parsedInfo.message);
        createBubble(bubblePoints);
      }
      if (parsedInfo.methodName === 'UpdateBubblePosition') {
        const newBubblePosition = JSON.parse(parsedInfo.message);
        updateBubblePosition(newBubblePosition);
      }
      if (parsedInfo.methodName === 'NewNoteAdded') {
        const newNote = JSON.parse(parsedInfo.message);
        createNote(newNote);
      }
      if (parsedInfo.methodName === 'openNote') {
        const noteToOpen = JSON.parse(parsedInfo.message);
        openNote(noteToOpen);
      }
      if (parsedInfo.methodName === 'NewLabelAdded') {
        const newLabel = JSON.parse(parsedInfo.message);
        createLabel(newLabel);
      }
      if (parsedInfo.methodName === 'openLabel') {
        const labelToOpen = JSON.parse(parsedInfo.message);
        openLabel(labelToOpen);
      }
      if (parsedInfo.methodName === 'UpdateLabelPosition') {
        const updatedLabel = JSON.parse(parsedInfo.message);
        updateLabelPosition(updatedLabel);
      }
      if (parsedInfo.methodName === 'GetCamerasByScanID') {
        const cameraId = JSON.parse(parsedInfo.message);
        setPointCloudId(Number(cameraId));
      }
      if (parsedInfo.methodName === 'UnityOpenImageRequest') {
        const pictureId = JSON.parse(parsedInfo.message);
        if (pointCloudPicId === null) {
          setPointCloudPicId(Number(pictureId));
          setIsMovementDisabled(1);
          setIsModalOpen(true);
        }
      }
      if (parsedInfo.methodName === 'UnityTagsRequest') {
        if (parsedInfo.message.length > 0) {
          const ids = JSON.parse(parsedInfo.message);
          setTagsIds(ids);
        }
      }
      if (parsedInfo.methodName === 'UnityExpressionsRequest') {
        if (parsedInfo.message.length > 0) {
          const ids = JSON.parse(parsedInfo.message);
          setExpressionsIds(ids);
        }
      }
      if (parsedInfo.methodName === 'NewWidgetAdded') {
        if (parsedInfo.message.length > 0) {
          const coordinates = JSON.parse(parsedInfo.message);
          setSelectedWidget(null);
          setWidgetCoordinates(coordinates);
          setWidgetModalMode('create');
        }
      }
      if (parsedInfo.methodName === 'OpenWidget') {
        if (parsedInfo.message.length > 0) {
          const id = JSON.parse(parsedInfo.message);
          setSelectedWidget(id);
        }
      }
      if (parsedInfo.methodName === 'UpdateWidgetPosition') {
        if (parsedInfo.message.length > 0) {
          const updatedWidgetPosition = JSON.parse(parsedInfo.message);
          setWidgetPositionUpdate(updatedWidgetPosition);
        }
      }
      if (parsedInfo.methodName === 'DeleteWidget') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'widget', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteBubble') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'bubble', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteLabel') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'label', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteNote') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'note', id: itemToDelete });
        }
      }
    });
  }

  useEffect(() => {
    if (itemToDelete && itemToDelete.id !== null) {  // Check if itemToDelete and id are valid
      const removeItem = async () => {
        const itemsConfig: Record<string, (id: any) => Promise<any>> = {
          widget: deleteWidget,
          bubble: deleteBubble,
          label: deleteLabel,
          note: deleteNote
        };

        const api = itemsConfig[itemToDelete.item];
        if (api) {
          try {
            const response = await api(itemToDelete.id);
            if (response.status === 200) {
              setItemToDelete({ item: '', id: null });
            } else {
              console.error(`${itemToDelete.item} deletion failed with status: ${response.status}`);
            }
          } catch (error) {
            console.error(`Error deleting ${itemToDelete.item}:`, error);
          }
        } else {
          console.warn(`No delete function found for item type: ${itemToDelete.item}`);
        }
      };

      removeItem();
    }
  }, [itemToDelete]);

  useEffect(() => {
    if (widgetPositionUpdate !== null) {
      const updateWidgetPosotionApi = async () => {
        const response = await updateWidgetPosition(widgetPositionUpdate);
        if (response.status === 200) {
          setWidgetPositionUpdate(null);
        }
        else {
          console.error('widget not updated');
        }
      };
      updateWidgetPosotionApi();
    }
  }, [widgetPositionUpdate]);

  useEffect(() => {
    if (window.vuplex) {
      addMessageListener();
    }
    else {
      window.addEventListener('vuplexready', addMessageListener);
    }
  }, []);

  useEffect(() => {
    if (widgetCoordinates.length > 0) {
      setWidgetData((prev: any) => ({
        ...prev,
        x: widgetCoordinates[0],
        y: widgetCoordinates[1],
        z: widgetCoordinates[2]
      }));
    }
  }, [widgetCoordinates]);

  const getFileData = async (id: any) => {
    const response = await getFileByUniqueId(id);
    if (response.status === 200) {
      return response.data;
    }
  };

  const onFileClick = async (file: any) => {
    const { uniqueId, fileName } = file;
    const data = await getFileData(uniqueId);
    setPreviewData({
      uniqueId, fileName, data
    });
    setIsModalOpen(true);
  };

  const togglePins = () => {
    setShowPins((prev) => !prev);
  };

  useEffect(() => {
    if (minifiedImgPreviewData.leftPanelId.id !== 0) {

      addItemToPosition('bottomLeft', {
        type: 'preview',
        data: {
          id: minifiedImgPreviewData.leftPanelId.id,
          data: minifiedImgPreviewData.leftPanelId.data,
          fileName: minifiedImgPreviewData.leftPanelId.fileName || '',
          fileType: getFileExtension(minifiedImgPreviewData.leftPanelId.fileName || ''),
        },
      });

      const controller = new AbortController();
      const signal = controller.signal;

      !minifiedImgPreviewData.leftPanelId.fileName && fetchPictureData({
        id: minifiedImgPreviewData.leftPanelId.id.toString(),
        signal,
        onSuccess: (rawData) => {
          addItemToPosition('bottomLeft', {
            type: 'preview',
            data: {
              id: minifiedImgPreviewData.leftPanelId.id,
              data: rawData.data,
              fileName: rawData.fileName,
              fileType: getFileExtension(rawData.fileName),
            },
          });
        },
        onError: (error) => {
          console.log(error);
        },
      });

      return () => {
        controller.abort();
      };
    }
  }, [minifiedImgPreviewData.leftPanelId]);

  useEffect(() => {
    if (minifiedImgPreviewData.rightPanelId.id !== 0) {
      addItemToPosition('bottomRight', {
        type: 'preview',
        data: {
          id: minifiedImgPreviewData.rightPanelId.id,
          data: minifiedImgPreviewData.rightPanelId.data,
          fileName: minifiedImgPreviewData.rightPanelId.fileName || '',
          fileType: getFileExtension(minifiedImgPreviewData.rightPanelId.fileName || ''),
        },
      });

      const controller = new AbortController();
      const signal = controller.signal;

      !minifiedImgPreviewData.rightPanelId.fileName && fetchPictureData({
        id: minifiedImgPreviewData.rightPanelId.id.toString(),
        signal,
        onSuccess: (rawData) => {
          addItemToPosition('bottomRight', {
            type: 'preview',
            data: {
              id: minifiedImgPreviewData.rightPanelId.id,
              data: rawData.data,
              fileName: rawData.fileName,
              fileType: getFileExtension(rawData.fileName),
            },
          });
        },
        onError: (error) => {
          console.log(error);
        },
      });

      return () => {
        controller.abort();
      };
    }
  }, [minifiedImgPreviewData.rightPanelId]);

  const onLeftMinifyClick = (mode: string) => {
    if (mode === 'note') {
      addItemToPosition('bottomLeft', { type: 'note', data: { popupNoteId, notePopup } });
      setNoteModalOpen(false);
    }

    if (mode === 'doc') {
      addItemToPosition('bottomLeft', {
        type: 'doc',
        data: {
          id: previewData.uniqueId,
          data: previewData.data,
          fileName: previewData.fileName,
          fileType: getFileExtension(previewData.fileName),
        },
      });
      setIsModalOpen(false);
    }

    if (mode === 'widget') {
      addItemToPosition('bottomLeft', { type: 'widget', data: { WebGLContext, bubbleAllDetails, chartData, name: bubbleDetails?.name } });
      setModalOpen(false);
    }

    if (mode === 'preview') {
      if (pointCloudPicId) {
        updateLeftPanel({
          id: pointCloudPicId,
          data: pointCloudPicData.data,
          fileName: pointCloudPicData.fileName,
          fileType: getFileExtension(pointCloudPicData.fileName),
          minPicId,
          maxPicId,
        });
      } else {
        updateLeftPanel({
          id: 0,
          data: '',
          fileName: '',
          fileType: '',
          minPicId: 0,
          maxPicId: 0,
        });
        addItemToPosition('bottomLeft', {
          type: 'preview',
          data: {
            id: previewData.uniqueId,
            data: previewData.data,
            fileName: previewData.fileName,
            fileType: getFileExtension(previewData.fileName),
          },
        });
      }
      setIsModalOpen(false);
    }
    setSelectedTabLeft(minifiedMenuItems[0].data.length - 1);
  };

  const onRightMinifyClick = (mode: string) => {
    if (mode === 'note') {
      addItemToPosition('bottomRight', { type: 'note', data: { popupNoteId, notePopup } });
      setNoteModalOpen(false);
    }

    if (mode === 'widget') {
      addItemToPosition('bottomRight', { type: 'widget', data: { WebGLContext, bubbleAllDetails, chartData, name: bubbleDetails?.name } });
      setModalOpen(false);
    }

    if (mode === 'doc') {
      addItemToPosition('bottomRight', {
        type: 'doc',
        data: {
          id: previewData.uniqueId,
          data: previewData.data,
          fileName: previewData.fileName,
          fileType: getFileExtension(previewData.fileName),
        },
      });
      setIsModalOpen(false);
    }

    if (mode === 'preview') {
      if (pointCloudPicId) {
        updateRightPanel({
          id: pointCloudPicId,
          data: pointCloudPicData.data,
          fileName: pointCloudPicData.fileName,
          fileType: getFileExtension(pointCloudPicData.fileName),
          minPicId,
          maxPicId,
        });
      } else {
        updateRightPanel({
          id: 0,
          data: '',
          fileName: '',
          fileType: '',
          minPicId: 0,
          maxPicId: 0,
        });
        addItemToPosition('bottomRight', {
          type: 'preview',
          data: {
            id: previewData.uniqueId,
            data: previewData.data,
            fileName: previewData.fileName,
            fileType: getFileExtension(previewData.fileName),
          },
        });
      }
      setIsModalOpen(false);
    }
  };

  const onFullScreenClick = async (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc', data: any) => {

    if (mode === 'note') {
      setNoteId(data);
      setNoteModalOpen(true);
    }

    if (mode === 'preview') {
      if (data.data) {
        setIsModalOpen(true);
        setPointCloudPicId(data.id);
        setPointCloudPicData({ uniqueId: data.id, data: data.data, fileName: data.fileName });
      }
    }

    if (mode === 'doc') {
      const result = findItemByUUID(minifiedMenuItems, data);
      if (result) {
        setPreviewData({ uniqueId: data, fileName: result.fileName, data: result.data });
        setIsModalOpen(true);
      }
    }

    if (mode === 'widget') {
      setChartData(data.chartData);
      setbubbleAllDetails({ bubbletype: data.widgetData.bubbletype, unitId: data.widgetData.unitId, equipmentId: data.widgetData.equipmentId });
      setModalOpen(true);
    }
  };

  const genModalItems = (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc' | 'pins', data: any, position: 'left' | 'right') => {
    if (mode === 'note') {
      return (
        <div className="w-full h-full opacity-95">
          <Note
            size="small"
            noteId={data.popupNoteId}
            onFullScreenClick={onFullScreenClick}
            onLeftMinifyClick={() => null}
            onRightMinifyClick={() => null}
            onFileClick={onFileClick}
            noteDetails={data.notePopup}
            closeHandler={() => removeMinifiedTab(mode, position)}
            updateNotes={updateNotes}
            pauseUnity={pauseUnity}
            noteFormConfig={noteFormConfig}
            hooks={allHooks}
          />
        </div>
      );
    }
    if (mode === 'preview' || mode === 'doc') {
      return (
        <PreviewFiles
          closeHandler={() => removeMinifiedTab(mode, position)}
          data={data.data}
          position={position}
          fileName={data.fileName}
          picId={data.id}
          size='small'
          onLeftMinifyClick={onLeftMinifyClick}
          onRightMinifyClick={onRightMinifyClick}
          onFullScreenClick={onFullScreenClick}
          type='unity'
          fileType={data.fileType}
          setIsModalOpen={setIsModalOpen}
          onLeftArrowClick={onLeftArrowClick}
          onRightArrowClick={onRightArrowClick}
        />
      );
    }
    if (mode === 'widget') {
      return (
        <div className="w-full h-full opacity-95">
          <ChartsContainer
            closeHandler={() => removeMinifiedTab(mode, position)}
            size="small"
            onLeftMinifyClick={onLeftMinifyClick}
            onRightMinifyClick={onRightMinifyClick}
            name="Widget"
            setModalOpen={setModalOpen}
            onFullScreenClick={onFullScreenClick}
            WebGLContext={WebGLContext}
            bubbleAllDetailsData={data.bubbleAllDetails}
            chartRawData={data.chartData}
            handleConfigClick={handleConfigClick}
            chartType={chartType}
            hooks={allHooks}
            unityChartsContainerConfig={unityChartsContainerConfig}
          />
        </div>
      );
    }
    if (mode === 'pins') {
      return (
        <div className="w-full h-full max-h-full pb-12 bg-dark opacity-95 overflow-hidden overflow-y-auto">
          <div className="p-2 flex flex-wrap gap-2 overflow-y-auto">
            {unityPins.map((pin: any, index: number) => (
              <Pin key={pin.id || index} data={pin} unityPin fixedWidth={false} hooks={allHooks} />
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <WebGLContext.Provider
      value={{
        resumeUnity,
        pauseUnity,
        chartData,
        bubbleDetails,
        handleModalLoader,
        handleCloseModal,
        modalOpen,
        modalLoader,
        ticketTags,
        ticketTagsHandler,
        popupBubbleId,
        configureBubbleHandler,
        chartType,
        setChartType,
        refreshUnityData,
        bubbleAllDetails
      }}
    >
      {modalOpen && chartData && <ChartsContainer size="regular" closeHandler={() => null} bubbleAllDetailsData={null} chartRawData={null} name="" onFullScreenClick={() => null} onRightMinifyClick={onRightMinifyClick} onLeftMinifyClick={onLeftMinifyClick} setModalOpen={setModalOpen} WebGLContext={WebGLContext} handleConfigClick={handleConfigClick} chartType={chartType} hooks={allHooks} unityChartsContainerConfig={unityChartsContainerConfig} />}

      {widgetModalMode !== 'none' && <Widget
        units={units}
        equipments={equipments}
        widgetData={widgetData}
        setWidgetData={setWidgetData}
        widgetModalMode={widgetModalMode}
        setWidgetModalMode={setWidgetModalMode}
        unityWidgetConfig={unityWidgetConfig}
        hooks={allHooks}
      />}

      {noteModalOpen && (
        <div className="fixed inset-0 z-10 w-full h-screen">
          <div
            className=
            "h-full absolute z-20 inset-0 w-full bg-black/70"
          />

          <div className="top-1/2 w-full h-auto opacity-95 rounded-md z-30 absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:max-w-[650px] max-h-[80vh]">
            <Note
              size="regular"
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={() => null}
              noteId={popupNoteId}
              onFileClick={onFileClick}
              noteDetails={notePopup}
              closeHandler={noteCloseHandler}
              updateNotes={updateNotes}
              pauseUnity={pauseUnity}
              noteFormConfig={noteFormConfig}
              hooks={allHooks}
            />
          </div>
        </div>
      )}

      {LabelModalOpen && (
        <Label
          LabelId={popupLabelId}
          LabelDetails={LabelPopup}
          closeHandler={LabelCloseHandler}
          updateLabels={updateLabels}
          pauseUnity={pauseUnity}
          resumeUnity={resumeUnity}
          allLabels={allLabels}
          LabelConfig={labelConfig}
        />
      )}

      {/* {showPins && unityPins && unityPins.length > 0 && (
        <div className="absolute right-0 2xl:right-2 bottom-0 2xl:bottom-3 rounded-md 3xl:p-3 p-1 flex flex-col gap-1 2xl:gap-3">
          {unityPins.slice(0, 6).map((pin: any) => (
            <Pin key={pin.id} data={pin} unityPin hooks={allHooks} />
          ))}
          <div className="flex items-end justify-between h-max w-full">
            <button className="btn" onClick={togglePins}>Hide Pins</button>
            {!unpinConfirmation && <button className="btn-danger" onClick={() => setUnpinConfirmation(true)}>Unpin All Tags</button>}
            {unpinConfirmation &&
              <div className="flex gap-5">
                <button className="btn-sec" onClick={() => setUnpinConfirmation(false)}>Keep</button>
                <button className="btn-danger" onClick={() => {
                  unpinAllWidgets(2);
                  setUnpinConfirmation(false);
                }}>Remove</button>
              </div>}
          </div>
        </div>
      )} */}
      {/* 
      {!showPins && unityPins && unityPins.length > 0 && (
        <div className="absolute right-10 2xl:right-2 bottom-0 2xl:bottom-3 rounded-md 3xl:p-3 p-1 flex flex-col gap-1 2xl:gap-3 w-[18.5vw]">
          <div className="flex items-end justify-start h-max w-full">
            <button className="btn" onClick={togglePins}>Show Pins</button>
          </div>
        </div>
      )} */}

      {pointCloudPicId && isModalOpen && (
        <div className="h-screen w-full flex items-center justify-center align-middle relative">
          <div className="relative">
            <PreviewFiles
              data={pointCloudPicData.data}
              fileName={pointCloudPicData.fileName}
              size='regular'
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={onFullScreenClick}
              type='unity'
              fileType={getFileExtension(pointCloudPicData.fileName)}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              onLeftArrowClick={onLeftArrowClick}
              onRightArrowClick={onRightArrowClick}
            />
          </div>
        </div>
      )}

      {previewData.uniqueId !== '' && isModalOpen &&
        <div className="h-screen w-full flex items-center justify-center align-middle relative">
          <div className="relative z-50">
            <PreviewFiles
              data={previewData.data}
              fileName={previewData.fileName}
              size='regular'
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={onFullScreenClick}
              type='unity'
              fileType={getFileExtension(previewData.fileName)}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              onLeftArrowClick={onLeftArrowClick}
              onRightArrowClick={onRightArrowClick}
            />
          </div>
        </div>
      }

      <div className="relative">
        <div id="unity-container">
          <SplashScreen
            open={!isLoaded || showLogo}
            logo={true}
            status={loadingStatus}
          />
          <Unity
            unityProvider={unityProvider}
            className="unityApp"
            style={{
              width: "100vw",
              height: "100vh",
              visibility: isLoaded || showLogo ? "visible" : "hidden",
            }}
          />
        </div>
        {minifiedMenuOpen && <MinifiedMenu genModalItems={genModalItems} allHooks={allHooks} visibilityParams={menuVisibilityParams} setVisibilityParams={setMenuVisibilityParams} />}
      </div>

      <UnityMenu TimelineShown={TimelineShown} isModalOpen={isModalOpen} />

    </WebGLContext.Provider>
  );
};

export default WebGL;